"use strict";

require("core-js/modules/es.object.freeze");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = Object.freeze({
  FILE_NAME_LARGE_CODE: 'name-too-large',
  FILE_NAME_LARGE_MESSAGE: 'Document upload failure: file name cannot be more than <LENGTH> characters. Please rename the file and try again.'
});

exports.default = _default;
//# sourceMappingURL=FileInputErrorCode.js.map